export default {
  user: {}
};